import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSaleRequest = {};
var _getSaleResponse = { saleDetails: '_saleDetails' };
var _saleDetails = { saleEndDate: 'google.protobuf.Timestamp' };
function resolveComWixpressPremiumStoreSalesV1PremiumSalesUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-store',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/pricing',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/studio/pricing',
                destPath: '/upgradeWebsite',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/premium-store',
                destPath: '',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/store/plans/premiumStatus',
                destPath: '/api/plans/premiumStatus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Check if there is a sale running for a specific product type */
export function getSale(payload) {
    var _a = serializer(_getSaleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSaleResponse, { _saleDetails: _saleDetails }).fromJSON;
    function __getSale(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.sales',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.sales.v1.PremiumSales.GetSale',
            url: resolveComWixpressPremiumStoreSalesV1PremiumSalesUrl({
                protoPath: '/api/v1/sale/{productTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSale.fromReq = fromReq;
    __getSale.__isAmbassador = true;
    return __getSale;
}
//# sourceMappingURL=http.impl.js.map